// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Ia648","iconBox":"style__iconBox__iHI1d","imageIcon":"style__imageIcon__aVsY7","textBox":"style__textBox__UHyQk"};